<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ header }}
    </div>
    <div class="p-2">
      <FormulateForm
        v-model="values"
        :schema="schema"
        @submit="submitHandler"
      />
      <p class="text-red-600 ml-4 mb-2 mt-0">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  data() {
    return {
      msg: null
    };
  },
  methods: {
    hideMsg: function() {
      this.msg = null;
    },
    parseResponse: function(ok, msg) {
      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
      } else {
        this.msg = msg;
      }
    }
  },
  watch: {
    msg(newvalue) {
      if (this.msg) {
        setTimeout(this.hideMsg, 5000);
      }
    }
  }
};
</script>

<style>
.formulate-form {
  @apply font-opensans;
}

.formulate-input-wrapper {
  @apply mb-2 grid grid-cols-2;
}

.disabled {
  @apply appearance-none bg-transparent;
}

.editMode {
  @apply bg-transparent border-b border-gray-500 border-dashed;
}

.formulate-input-label {
  @apply font-bold;
}

.btn {
  @apply ml-2 mb-4 bg-gray-100  text-blue-700 font-semibold  py-2 px-4 border border-mi-blue-400 rounded;
}
.btn:hover {
  @apply bg-mi-blue-400 text-white border-transparent;
}

.btn.disabled {
  @apply hidden;
}
</style>
